<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from './wrappers/BaseModal.vue'
import { workingDate } from '../App.vue'
import { isSameDay } from 'date-fns'
import { useGlobalTimesheetInstance } from '../store/useGlobalTimesheetInstance'
import { storeToRefs } from 'pinia'

const maintenanceRef = ref(false)
/**
 * To prevent issues when working in a small window after midnight,
 * we lock down certain actions in this defined time frame, To use
 * this, simply wrap your action in this checkMaintenance
 * function. If within the Maintenance window, it will
 * cancel the action and show this modal.
 */
export const checkMaintenance = (fn: any) => async () => {
  const { timesheet } = storeToRefs(useGlobalTimesheetInstance())
  const d = new Date()
  // //between 12 AM and 12:01 AM
  //first check if we are editing a timesheet (curr day wont = working day)
  //then check if the timeline date is same as current date -- this
  //would mean we have passed the incomplete timecard step, and we
  //thus don't need a full minute of inactivity
  if (!timesheet.value && !isSameDay(workingDate.value, d)) {
    maintenanceRef.value = true
    return
  } else {
    if (fn) {
      return await fn()
    }
  }
}

export default defineComponent({
  name: 'ModalMaintenance',
  components: {
    BaseModal,
  },
  setup() {
    const { t } = useI18n({ useScope: 'global' })
    const label = (key: string) => t(`form.${key}`)

    return {
      label,
      maintenanceRef,
    }
  },
})
</script>
<template>
  <BaseModal v-model="maintenanceRef">
    <template #title>{{ label('maintenance') }}</template>
    <template #content> {{ label('maintenanceMessage') }} </template>
    <template #actions>
      <q-btn flat :label="label('close')" v-close-popup />
    </template>
  </BaseModal>
</template>
